(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery-new"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const desktopGalleryQuery = window.matchMedia('(min-width: 851px)');
    const productMediaList = document.querySelector('.product__media-list.swiper');
    const initialSlide = productMediaList ? Number(productMediaList.dataset.position) - 1 : 0;

    function createThumbsSlider() {
        const productThumbnailList = document.querySelector('.product__thumbnail-list.swiper');

        if (!desktopGalleryQuery.matches || !productThumbnailList) return null;

        return new Swiper(productThumbnailList, {
            slidesPerView: 4,
            loop: false,
            spaceBetween: 20,
            direction: 'vertical',
            mousewheelControl: true,
            freeMode: true,
            threshold: 15,
            navigation: {
                nextEl: '.product__thumbnail-wrapper .swiper-button-next'
            },
            breakpoints: {
                851: {
                    spaceBetween: 20
                },
                1151: {
                    spaceBetween: 40
                }
            }
        });
    }

    function createProductSlider(slideIndex) {
        if (!productMediaList) return;

        window.productThumbsSlider = createThumbsSlider();

        const sliderOptions = {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 0,
            initialSlide: Math.max(slideIndex, 0),
            scrollbar: {
                el: '.product__media-scrollbar',
                draggable: true
            },
            navigation: {
                prevEl: '.product__media-list .swiper-button-prev',
                nextEl: '.product__media-list .swiper-button-next'
            },
            breakpoints: {
                851: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            }
        };

        if (window.productThumbsSlider) {
            sliderOptions.thumbs = {
                swiper: window.productThumbsSlider
            };
        }

        window.productSlider = new Swiper(productMediaList, sliderOptions);
    }

    function destroyProductSlider(slider) {
        if (slider && !slider.destroyed) {
            slider.destroy(true, true);
        }
    }

    function rebuildProductSliders() {
        const activeIndex = window.productSlider && !window.productSlider.destroyed ? window.productSlider.realIndex : initialSlide;

        destroyProductSlider(window.productSlider);
        destroyProductSlider(window.productThumbsSlider);

        window.productSlider = null;
        window.productThumbsSlider = null;

        createProductSlider(activeIndex);
    }

    createProductSlider(initialSlide);

    if (desktopGalleryQuery.addEventListener) {
        desktopGalleryQuery.addEventListener('change', rebuildProductSliders);
    } else {
        desktopGalleryQuery.addListener(rebuildProductSliders);
    }

    // Zoom
    initZoom();
    window.addEventListener('resize', event => {
        initZoom();
    });

    function initZoom() {
        if (window.innerWidth < 769) {
            $('.product__media').trigger('zoom.destroy');
        } else {
            $('.product__media').zoom({magnify: 1.5, url: $(this).data('fullsize')});
        }
    }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    // Size chart dropdown
  const sizeChart = document.querySelector('.size-chart');
  const sizeChartButton = document.querySelector('.product__size-chart');

  sizeChartButton.addEventListener('click', event => {
    sizeChart.classList.add('is-visible');
    document.body.classList.add('scroll-lock');
  });

  const closeSizeChartButtons = document.querySelectorAll('.js-close-size-chart');
  closeSizeChartButtons.forEach(button => {
    button.addEventListener('click', event => {
      sizeChart.classList.remove('is-visible');
      document.body.classList.remove('scroll-lock');
    });
  });

  // Size chart tabs
  const tabs = document.querySelectorAll('.size-chart__tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', event => {
      const tabName = tab.dataset.tab;

      document.querySelector('.size-chart__tab.active').classList.remove('active');
      tab.classList.add('active');

      document.querySelector('.size-chart__content.active').classList.remove('active');
      document.querySelector(`.size-chart__content[data-tab="${tabName}"]`).classList.add('active');
    });
  });

  // Zoom
  // initZoom();
  window.addEventListener('resize', event => {
    // initZoom();
  });

  function initZoom() {
    if (window.innerWidth < 769) {
      $('.product__media').trigger('zoom.destroy');
    } else {
      $('.product__media').zoom({magnify: 1.5, url: $(this).data('fullsize')});
    }
  }
  } catch(e) { console.error(e); }
})();

})();
